import React from 'react';
import { getPromptLink } from '../../utils/helpers';
import { IMAGE_CONSTANT } from '../../constants/app';
import './style.css';

const PodcastBlogSponsor = () => {
  return (
    <div className="container">
      <div className="sponsor">
        <h3>Current & Past Sponsors</h3>
        <div className="d-flex align-items-center justify-content-center flex-wrap">
          <a
            target="_blank"
            href="https://drinklmnt.com/pages/free-gift-with-purchase?rfsn=6693721.70c72b&utm_medium=[…]tm_source=optimalbody&utm_campaign=agwp&utm_content=&utm_term="
            rel="noreferrer"
          >
            <img
              src={IMAGE_CONSTANT.LMNTSponsor}
              alt="brand-logo"
              className="px-2 px-lg-4 "
            />
          </a>
          <a
            target="_blank"
            href="http://www.naboso.com/docjenfit"
            rel="noreferrer"
          >
            <img
              src={IMAGE_CONSTANT.NabosoSponsor}
              alt="brand-logo"
              className="px-2 px-lg-4"
            />
          </a>
          <a
            target="_blank"
            href="https://www.thisisneeded.com/discount/OPTIMAL?rfsn=7902401.57e060&utm_source=refersion&utm_medium=affiliate&utm_campaign=7902401.57e060"
            rel="noreferrer"
          >
            <img
              src={IMAGE_CONSTANT.NeededSponsor}
              alt="brand-logo"
              className="px-2 px-lg-4"
            />
          </a>
          <a
            target="_blank"
            href="https://www.vivobarefoot.com/the-optimal-body"
            rel="noreferrer"
          >
            <img
              src={IMAGE_CONSTANT.VivoSponsor}
              alt="brand-logo"
              className="px-2 px-lg-4"
            />
          </a>
        </div>
        {/* <button type="button"> */}
        <a className="become-sponsor" href={getPromptLink('jen@jen.health')}>
          become a sponsor
        </a>
        {/* </button> */}
      </div>
    </div>
  );
};

export default PodcastBlogSponsor;
